import React from 'react';

const CreditsExtra = () => {
  return <h1>CreditsExtra Page</h1>;
};

export default CreditsExtra;
